import React from "react";
import moment from "moment";

import Framework from "@beardeddevops/react.framework";
import {Types, Collections, Parts, Elements} from "components";

import {Button} from "reactstrap";
import Tooltip from "@material-ui/core/Tooltip";
import TransactionObject from "components/TransactionObject";
import UniversalModalOverride from "components/UniversalModalOverride";


/**
 *  @property {Transactions_Collections_Object} state
 *  @property {object} model
 *  @property {Transactions_Collections_Properties} model.properties
 *  @property {Transactions_Collections_Is} model.is
 *  @property {Transactions_Collections_Has} model.has
 */
export default class Rental extends TransactionObject {
	constructor(props) {
		super(props, Types.Transactions_Collections._name);
		this.read = 'GET_RENTAL';
		this.update = typeof props.id !== 'undefined' && props.id ? 'POST_RENTAL' : 'PUT_RENTAL';
		this.delete = 'DELETE_RENTAL';

		this.afterCustomerSave = this.setNewObject('customer');
	}

	/**
	 * @param prevProps
	 * @param {Transactions_Collections_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		// noinspection JSValidateTypes
		/** @type {Transactions_Collections_Object} object */
		let object = this.state;

		//If Pkey has always been blank || this isn't the initial load so pkey is the same
		if (prevState.pkey === object.pkey || prevState.binary_id === object.binary_id) {
			if (prevState.location && object.location !== prevState.location) {
				this.setState({'bound_book': ''});
			}

			//If "Customer" select was updated, update corresponding Customer Information
			if (object.customers && (object.customer !== prevState.customer || object.customer_binary_id !== prevState.customer_binary_id) && object.customers.customer_addressess) {
				this.setState({
					'customer_name_first': object.customer ? object.customers.name_first : '',
					'customer_name_middle': object.customer ? object.customers.name_middle : '',
					'customer_name_last': object.customer ? object.customers.name_last : '',
					'customer_name_suffix': object.customer ? object.customers.name_suffix : '',
					'customer_street_1': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].street_1 : '',
					'customer_street_2': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].street_2 : '',
					'customer_city': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].city : '',
					'customer_county': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].county : '',
					'customer_state': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].state : '',
					'customer_zip': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].zip : '',
				});
			}
		}

		// Initialize "date" if it doesn't exist
		if (!object.date) {
			this.setState({date: moment().format('YYYY-MM-DD HH:mm:ss')});
		}
	}

	// noinspection JSUnusedGlobalSymbols
	/**
	 * @param {Transactions_Collections_Object} data
	 */
	loadSelfAfter(data) {
		if (typeof this.props.updateName === 'function') {
			this.props.updateName(data.transaction || (data.binary_id + '-' + data.pkey));
		}
	};

	form = () => {
		/** @type {Transactions_Collections_Properties} properties */
		let properties = this.model.properties;
		/** @type {Transactions_Collections_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>
						{/*#region Col 1*/}
						<div className={"col-md"}>
							{/*#region Details Section*/}
							<h4 className="section-title">Details</h4>
							<Parts.SelectLocation
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								locations={this.props.locations}
								states={this.props.states}
								filter={this.filterLocationOptions}
							/>
							<Parts.TransactionCustomer
								locations={this.props.locations}
								states={this.props.states}
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								history={this.props.history}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								afterCustomerSave={this.afterCustomerSave}
								disableFields={true}
							/>

							<div className="row">
								<div className="col-4">
									<span className="input-label">Date</span>
								</div>
								<div className={'col-8'}>
									<div className="form-group">
										<Framework.Elements.DateTime
											property={properties.date}
											value={object.date}
											error={object.date_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>

							{object.pkey &&
							<div className="row">
								<div className="col-4">
									<span className="input-label">Returned Date</span>
								</div>
								<div className={'col-8'}>
									<div className="form-group">
										<Framework.Elements.DateTime
											property={properties.returned_date}
											value={object.returned_date}
											error={object.returned_date_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>}

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Rental Item(s) Notes"}
									property={properties.notes}
									value={object.notes}
									error={object.notes_error}
									update={this.handleTextFieldPropertyUpdate}
									multiline={4}
								/>
							</div>
							{/*#endregion*/}
						</div>
						{/*#endregion*/}
						{/*#region Col 2*/}
						<div className={"col-md"}>
							{/*#region Items Section*/}
							<h4 className="section-title">
								Items
								<div className="pull-right">
									<Tooltip
										title="Products you have previously acquired and disposed / transferred can be found here."
										aria-label="Products you have previously acquired and disposed / transferred can be found here.">
										<Button onClick={this.handleToggleModalLookup} size={"sm"} color="primary" data-id={'quick-rental-products'}>
											<i className={"fa fa-barcode"}/>
											<span className="hidden-xs">&nbsp;&nbsp;Items</span>
										</Button>
									</Tooltip>

									<UniversalModalOverride
										locations={this.props.locations}
										states={this.props.states}
										history={this.props.history}
										name={"In Stock Products"}
										object={Collections.ProductsExisting}
										toggle={this.state.modalLookup}
										reportClose={this.handleReportProductClose}
										afterSave={this.addProducts}
										size={"xl"}
										status={"GET_IN_STOCK"}
										objectProps={{scannedCode: this.props.scannedCode}}
									/>

								</div>
							</h4>

							{object.transaction_entriess && object.transaction_entriess.map(
								(entry, i) =>
									<Elements.Item
										key={i}
										entry={entry}
										product={entry.products}
										onDelete={this.deleteProduct}
										onUpdate={this.updateProduct}
										openModal={this.handleToggleProductModel('productUpdate' + i)}
										reportClose={this.handleReportModalClose('productUpdate' + i)}
										modalUpdate={this.state['productUpdate' + i]}
										history={this.props.history}
										locations={this.props.locations}
										states={this.props.states}
									/>
							)}

							<p style={{textAlign: 'center', color: 'grey'}}><i>{object.transaction_entriess.length} Total Items</i></p>
							{/*#endregion*/}
						</div>
						{/*#endregion*/}
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
